import { render, staticRenderFns } from "./InstitutionsDashboard.vue?vue&type=template&id=155aa14f"
import script from "./InstitutionsDashboard.vue?vue&type=script&lang=js"
export * from "./InstitutionsDashboard.vue?vue&type=script&lang=js"
import style0 from "../../modules/core/scss/infoCards.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports